export default __webpack_public_path__ + "media/integrations/sketch-7b9a926d.svg";